export const all = async (source, predicate) => {
    for await (const item of source) {
        if (predicate(item) === false) {
            return false;
        }
    }
    return true;
};
